import React from "react";
import ProcessingSupport from "../../images/processingService/banner.jpg"
import { NavLink } from "react-router-dom";
import FinancialSupport from "../../images/coin-wooden-table.jpg";
import CBN from "../../images/gbrCBN/CBNBanner.webp";

import { Row, Col } from "react-bootstrap";

export default function AgriRetailerService() {
  const services = [
    // {
    //   title: "Community",
    //   image: Community,
    //   href: "/Community",
    // },

  
    {
      title: "Business Growth Service",
      image: ProcessingSupport,
      href: "/GrowthService",
      customPropValue : "FF1"
    },
    {
      title: "Financial Service",
      image: FinancialSupport,
      href: "/financial-services",
      customPropValue: "selling",

    },
    // {
    //   title: "Profit-generating Service",
    //   image: HoneyAsset,
    //   href: "/Profit-generating-Services",
    //   customPropValue: "selling",
    // },
    {
      title: "Billing Services",
      image: CBN,
      href: "/billing-service",
    },
   
  ];

  return (
    <div className="container for-farmer-section2 subSectionWrapper px-0">
      <h2 className="text-center title mb-4 mb-lg-5 container-title">
       Our Services for Agri-Retailers
      </h2>
      <Row className="justify-content-center">
        {services.map((e,i) => {
          const isExtenalLink = e.href.startsWith("https")
           const navLinkProps = {
            to: { pathname: e.href },
          };
  
          if (e.customPropValue) {
            navLinkProps.to.state = { customProp: e.customPropValue };
          }
          return (
            <Col md={4} sm={6} key={i}>
              {isExtenalLink ? 
              <a href={e.href} target="blank" rel = "noopener noreferrer">
              <div className="image-container mb-4">

              <img className="" src={e.image} alt="Investment asset" />
              </div>
              <h3 className="text-center container-heading1 mt-0 mb-4 text-decoration-none">
                {e.title}
              </h3>
              </a>
              :
              <NavLink {...navLinkProps}>
              <div className="image-container mb-4">

                <img className="" src={e.image} alt="Investment asset" />
                </div>
                <h3 className="text-center container-heading1 mt-0 mb-4 text-decoration-none">
                  {e.title}
                </h3>
              </NavLink>}
            </Col>
          );
        })}
      </Row>
    </div>
  );
}

